import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.PocketRaccoon,
  voices: {
    main: {
      description:
        "scratchy compact engineer tenor, fast abrasive confidence, junkyard inventor bite, nasal rasp, headset mic with sparks and tool-bench grit",
      seed: 11117,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Who are you calling a raccoon, huh?" },
      { id: "select_2", text: "Call me Pocket Raccoon. Just Pocket Raccoon." },
      { id: "select_3", text: "Who am I? I'm Pocket Raccoon!" },
      { id: "select_4", text: "Pocket Raccoon here. Who needs shootin'?" },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Groot's always with me. You'll see what I mean…",
      },
      {
        id: "spawn_2",
        text: "You and me, old pal. The best team in the galaxy!",
      },
      { id: "spawn_3", text: "Gotta admit, I'm feelin' a little squirrely…" },
      {
        id: "spawn_4",
        text: "Always a pleasure to work with ya, Tippy-Toe. You too, Doreen…",
      },
      { id: "spawn_5", text: "We can pull it off, I've been in worse gangs." },
      {
        id: "spawn_6",
        text: "Y'all a buncha dead weights, I can do this myself.",
      },
      {
        id: "spawn_7",
        text: "I like hanging around Groot because he gets me.",
      },
      {
        id: "spawn_8",
        text: "THIS looks like a gig for the Guardians of the Galaxy.",
      },
      { id: "spawn_9", text: "Call me a raccoon, we're gonna have a problem." },
      {
        id: "spawn_10",
        text: "From what I hear about this Doom character, I don't think I'm gonna like him very much.",
      },
      {
        id: "spawn_11",
        text: "So there are two Dooms, huh? Sounds like overpopulation.",
      },
      {
        id: "spawn_12",
        text: "Once we get this timeline thing sorted out, I'm taking a long vacation somewhere with lots of stuff to steal.",
      },
      {
        id: "spawn_13",
        text: "Friends have saved my life far more times than weapons… Even so, it's always nice to have a couple of weapons.",
      },
      { id: "spawn_14", text: "You can count on me, I got a plan." },
      { id: "spawn_15", text: "Just say it, there's nothin' I can't fix." },
      {
        id: "spawn_16",
        text: "Some of my best friends are crooks and villains.",
      },
      {
        id: "spawn_17",
        text: "I do the right thing unless the wrong thing is more fun.",
      },
      {
        id: "spawn_18",
        text: "I'm a good guy who occasionally takes stuff that doesn't belong to him.",
      },
      {
        id: "spawn_19",
        text: "When the chips are down, you want your heroes a little roguish and scruffy. Like me.",
      },
      {
        id: "spawn_20",
        text: "We guard the galaxy, sure, but sometimes we take stuff other people are guarding.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "Oh ho ho, I'm gonna get some revenge." },
      { id: "respawn_2", text: "I'm baa-aack." },
      { id: "respawn_3", text: "Oh, I'm not gonna make it easy." },
      { id: "respawn_4", text: "Things are gonna be different this time!" },
      { id: "respawn_5", text: "Pocket Raccoon's launchin' again!" },
      { id: "respawn_6", text: "Hahaha, you ain't got rid of me yet!" },
      { id: "respawn_7", text: "Here comes Pocket Raccoon again!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "Hey team, enjoy the amplifier!" }],
    ult_enemy: [{ id: "ult_enemy", text: "THIS is real fire power!" }],
    secondary: [
      { id: "secondary_1", text: "I'll patch you up." },
      { id: "secondary_2", text: "You're welcome." },
      { id: "secondary_3", text: "You're ready for action." },
    ],
    ability2: [
      { id: "ability2_1", text: "(deploy) THIS is a nice spot." },
      { id: "ability2_2", text: "(deploy) Relay deployed. It ain't cheap." },
      { id: "ability2_3", text: "(deploy) Armor packs here! Pay up!" },
    ],
    kill: [
      { id: "kill_1", text: "Rackin' em up!" },
      { id: "kill_2", text: "Long as I got bullets, I win." },
      { id: "kill_3", text: "This is way more fun than it should be." },
      { id: "kill_4", text: "Are we winning? I know I'm having a great time." },
      { id: "kill_5", text: "In your face!" },
      { id: "kill_6", text: "Put 'em down so they stay down." },
      { id: "kill_7", text: "You lost! To me!" },
      { id: "kill_8", text: "That must be really humiliating." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three? Already?" },
      { id: "multikill_2", text: "That's three!" },
      { id: "multikill_3", text: "Anybody else got three?" },
      { id: "multikill_4", text: "Oh yeah, five!" },
      { id: "multikill_5", text: "Five straight!" },
      { id: "multikill_6", text: "Five! I'm on a roll!" },
      { id: "multikill_7", text: "You had your chances." },
      { id: "multikill_8", text: "Somebody else coulda stepped up." },
      { id: "multikill_9", text: "Yeah, that's right. I got 'em all!" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Oh, yeah. Feelin' good." },
      { id: "low_hp_2", text: "That put a pep in my step." },
    ],
    healed: [
      { id: "healed_1", text: "I was a little messed up there, thanks." },
      { id: "healed_2", text: "Back from the brink, baby!" },
      { id: "healed_3", text: "Mm, mm, good." },
      { id: "healed_4", text: "That was tasty." },
    ],
  },
} satisfies VoiceScript;

export default script;
